<div class="EventAgenda">

  <div *ngIf="eventId">
    <h3 class="heading" >Event Agenda</h3>
    <hr class="headinghr">
  </div>
  
  <div  *ngIf="eventid">
    <h3 style="font-family: 'Lato' !important;" class="symposium-heading">Event Agenda</h3>
    <hr class="symposium-headinghr">
  </div>

</div>

<div *ngFor="let schedule of mobilePremiereDetails.cinejoySpotlightsSchedule" class="event-agenda-div">
  <!-- *************** REDCARPET *************** -->
  <div class="event-details">

    <div fxLayout="row " class="event-details-div">
      <div class="timing">
        {{schedule.scheduleTimeText | date:"h:mma"}}
      </div>
      <div class="top-circle"></div>
      <div class="scheduleMainText" *ngIf="schedule.scheduleMainText !== 'GS1' && schedule.scheduleMainText !== 'GS2' && schedule.scheduleMainText !== 'Opening Remarks'">{{schedule.scheduleMainText}} {{schedule.scheduleMainText === 'Screening of' ? mobilePremiereDetails.name : '' }}</div>
      <div class="scheduleMainText" *ngIf="schedule.scheduleMainText === 'GS1' ">Groups join now for Lobby Meetup.</div>
      <div class="scheduleMainText" *ngIf="schedule.scheduleMainText === 'GS2' ">Group Sharing Lobby Finale</div>
      <div class="scheduleMainText" *ngIf="schedule.scheduleMainText === 'Opening Remarks' ">Opening Presentation</div>

    </div>

    <div class="red-dotted-line">
      <div class="scheduleSubText">{{schedule.scheduleSubText}}</div>
    </div>

  </div>

  <!-- *************** -xxxxx- *************** -->
</div>

<!-- Celebrations event agenda -->
<div *ngFor="let schedule of mobilePremiereDetails.schedule" class="event-agenda-div">
  <!-- *************** Everything *************** -->
  <div class="event-details">

    <div fxLayout="row wrap" class="event-details-div">

      <div style="font-family: 'Lato-Bold' !important;" class="timing">{{schedule.scheduleTimeText | date:"h:mma"}}</div>

      <div class="top-circle"></div>

      <div style="font-family: 'Lato-Bold' !important;" fxFlex.md=40 class="scheduleMainText">{{schedule.scheduleMainText}}
      </div>

    </div>

    <div class="red-dotted-line">

      <div style="font-family: 'Lato' !important;" class="scheduleSubText">{{schedule.scheduleSubText}}</div>

    </div>

  </div>

</div>
